import { LuShip, LuAward, LuCalendarDays } from "react-icons/lu";
import { Section, Container, SectionEyebrow } from "../ui/Section";
import { AnimatedNumber } from "../ui/AnimatedNumber";
import { mediaUrl } from "../../utils/media";
import {
  MotionItem,
  fadeUp,
  fadeUpSmall,
  fadeLeft,
  scaleIn,
} from "../ui/Motion";
import {
  Grid,
  ImageSide,
  CollageMain,
  CollageOffsetTop,
  CollageOffsetBottom,
  TextContent,
  Title,
  Description,
  StatsRow,
  Stat,
  StatIcon,
  StatNumber,
  StatLabel,
  Divider,
  LearnMoreLink,
} from "./styles/AboutSnippet.styles";

function AboutSnippet() {
  return (
    <Section $bg="white">
      <Container>
        <Grid>
          <ImageSide $variants={fadeLeft}>
            <CollageMain
              src={mediaUrl(
                "/images/princess/F65/exterior/large/exterior-08_f65-exterior-shot-5.webp",
              )}
              alt="Princess F65 exterior"
              loading="lazy"
            />
            <CollageOffsetTop
              src={mediaUrl(
                "/images/princess/S80/interior/large/interior-01_s80-interior-saloon-silver-oak.webp",
              )}
              alt="Princess S80 interior saloon"
              loading="lazy"
            />
            <CollageOffsetBottom
              src={mediaUrl(
                "/images/princess/S80/exterior/large/exterior-02_s80-exterior-white-hull-3.webp",
              )}
              alt="Princess S80 exterior detail"
              loading="lazy"
            />
          </ImageSide>

          <TextContent slow>
            <MotionItem $variants={fadeUpSmall}>
              <SectionEyebrow>About LUMA Yachting</SectionEyebrow>
            </MotionItem>

            <MotionItem $variants={fadeUp}>
              <Title>
                More Than a <em>Brokerage</em>
              </Title>
            </MotionItem>

            <MotionItem $variants={fadeUpSmall}>
              <Description>
                As authorized representatives of Princess Yachts, LUMA Yachting
                offers the full Princess range alongside a curated selection of
                premium new builds and distinguished pre-owned vessels, backed
                by personalized guidance from discovery to delivery.
              </Description>
            </MotionItem>

            <MotionItem $variants={fadeUp}>
              <StatsRow>
                <MotionItem $variants={scaleIn}>
                  <Stat>
                    <StatIcon>
                      <LuShip />
                    </StatIcon>
                    <StatNumber>
                      <AnimatedNumber value={50} />+
                    </StatNumber>
                    <StatLabel>Yachts</StatLabel>
                  </Stat>
                </MotionItem>
                <MotionItem $variants={scaleIn}>
                  <Stat>
                    <StatIcon>
                      <LuAward />
                    </StatIcon>
                    <StatNumber>
                      <AnimatedNumber value={15} />+
                    </StatNumber>
                    <StatLabel>Brands</StatLabel>
                  </Stat>
                </MotionItem>
                <MotionItem $variants={scaleIn}>
                  <Stat>
                    <StatIcon>
                      <LuCalendarDays />
                    </StatIcon>
                    <StatNumber>
                      <AnimatedNumber value={10} />+
                    </StatNumber>
                    <StatLabel>Years</StatLabel>
                  </Stat>
                </MotionItem>
              </StatsRow>
            </MotionItem>

            <MotionItem $variants={fadeUpSmall}>
              <Divider $margin="0 0 2rem" />
            </MotionItem>

            <MotionItem $variants={fadeUpSmall}>
              <LearnMoreLink to="/about">Discover our story</LearnMoreLink>
            </MotionItem>
          </TextContent>
        </Grid>
      </Container>
    </Section>
  );
}

export default AboutSnippet;
